import { Project, STORAGE_KEYS } from './types';

// Get all projects from localStorage
export const getAllProjects = (): Project[] => {
  try {
    const projectsData = localStorage.getItem(STORAGE_KEYS.PROJECTS);
    if (projectsData) {
      return JSON.parse(projectsData);
    }
  } catch (error) {
    console.warn('Failed to load projects from localStorage:', error);
  }
  return [];
};

// Save projects to localStorage
export const saveProjects = (projects: Project[]): void => {
  try {
    console.log('Saving projects to localStorage:', projects);
    localStorage.setItem(STORAGE_KEYS.PROJECTS, JSON.stringify(projects));
    console.log('Successfully saved to localStorage');

    // Verify it was saved
    const saved = localStorage.getItem(STORAGE_KEYS.PROJECTS);
    console.log(
      'Verification - data in localStorage:',
      saved ? JSON.parse(saved) : null
    );
  } catch (error) {
    console.warn('Failed to save projects to localStorage:', error);
  }
};

// Get current project ID
export const getCurrentProjectId = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.CURRENT_PROJECT_ID);
  } catch {
    return null;
  }
};

// Set current project ID
export const setCurrentProjectId = (projectId: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.CURRENT_PROJECT_ID, projectId);
  } catch (error) {
    console.warn('Failed to save current project ID:', error);
  }
};

// Generate unique project ID
export const generateProjectId = (): string => {
  try {
    const counter = parseInt(
      localStorage.getItem(STORAGE_KEYS.PROJECT_COUNTER) || '0',
      10
    );
    const newCounter = counter + 1;
    localStorage.setItem(STORAGE_KEYS.PROJECT_COUNTER, newCounter.toString());
    return `project_${newCounter}_${Date.now()}`;
  } catch {
    return `project_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
};

// Clear all projects
export const clearAllProjects = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEYS.PROJECTS);
    localStorage.removeItem(STORAGE_KEYS.CURRENT_PROJECT_ID);
    localStorage.removeItem(STORAGE_KEYS.PROJECT_COUNTER);
  } catch (error) {
    console.warn('Failed to clear projects from localStorage:', error);
  }
};
